export var NAME = 'fapiao';
export var ORGANIZATIONS_LOADED = "".concat(NAME, "/ORGANIZATIONS_LOADED");